import { useRef, FC, memo, useMemo, useState } from 'react';
import { Image } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import defaultUniLogoSrc from '../../../assets/images/uni_logo.png';
import { getUniLogoSrc } from '../../../utilities/helpers';
import { getUniName } from '../../../store/selectors';

type Props = {
  className?: string;
  alt?: string;
};
export const UniLogo: FC<Props> = memo(({ className }) => {
  const uniName: string = useSelector(getUniName);
  const [alt, setAlt] = useState(uniName);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleOnError = () => {
    if (imgRef.current) {
      imgRef.current.src = defaultUniLogoSrc;
      setAlt('Enroly logo');
    }
  };
  const uniLogoSrc = useMemo(() => getUniLogoSrc(), []);
  return (
    <Image
      height="6rem"
      objectFit="contain"
      className={className}
      ref={imgRef}
      src={uniLogoSrc}
      alt={alt}
      onError={handleOnError}
    />
  );
});
